export default __webpack_public_path__ + "static/media/ariel_mayer.412d3b80.jpg";